<template>
    <div id="lonterm">
        <img src="./../../assets/annual/4.png" alt="">
        <img src="http://static.yuread.cn/quick/7q7.png" alt="" class="img2">
        <p class="btn">
            <button @click="doRecharge">立即订购</button>
        </p>
        <img src="./../../assets/annual/6.png" alt="">
    </div>
</template>

<script>
    export default {
        name: "Lonterm",
        data(){
            return {
                active:1,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 11,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#lonterm{
    min-height: 1500px;background-color: #281b46;overflow: auto;position: relative;
    img{width: 100%;}
    .img2{margin-top: -400px;}
    .btn{text-align: center;margin: 130px 0;
        button{background: #ebe25d;color: #281b46;border: none;padding: 10px 40px;font-size: 30px;border-radius: 10px;}

    }
}
</style>
